import { Select } from 'antd'
import { useRecoilState } from 'recoil'
import { ImgYear, ImgData } from '../../../../state/atom'
const { Option } = Select

export const YearMenu = () => {
  const anni = [
    2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009, 2008, 2007, 2006, 2005, 2004, 2003, 2002,
    2001, 'ziano_maltempo', 'ziano_panorami_architettura', 'ziano_uva_vendemmia', 'ziano_vicobarock',
  ]
  const [anno, setAnno] = useRecoilState(ImgYear)
  const [Images, setImages] = useRecoilState(ImgData)

  async function onChange(value: any) {
    await setImages([])
    setAnno(value)
  }

  return (
    <>
      <Select
        style={{ width: '80%', marginBottom: 10, maxWidth: 300 }}
        placeholder='Seleziona anno'
        optionFilterProp='children'
        onChange={onChange}
      >
        {anni.map((e, key) => {
          return (
            <Option key={key} value={e}>
              {e}
            </Option>
          )
        })}
      </Select>
    </>
  )
}
